import apiClient from './client'

export interface UserInfo {
  name: string
  email: string
  code: string
  roleName: string | null
  roleCode: string | null
  tenantName: string
  tenantCode: string
  tenantAssistanceEnabled: boolean | null
  permissions: Record<string, Record<string, boolean>> | Array<{ module: string; action: string }>
  userBoardingSurveyComplete: boolean
  initials: string
  avatar: { class: string }
  userOnboardingChecklistData: Record<string, unknown>
  apiKey: string | null
  serverUrl: string
  isPlatformAdmin: boolean
}

export interface LoginRequest {
  email: string
  password: string
}

export interface SSOLoginRequest {
  token: string
}

export const authApi = {
  async login(data: LoginRequest): Promise<UserInfo> {
    const response = await apiClient.post<UserInfo>('/login', data)
    return response.data
  },

  async ssoLogin(data: SSOLoginRequest): Promise<UserInfo> {
    const response = await apiClient.post<UserInfo>('/sso/login', data)
    return response.data
  },

  async logout(): Promise<void> {
    await apiClient.post('/logout')
  },

  async getCurrentUser(): Promise<UserInfo> {
    const response = await apiClient.get<UserInfo>('/user')
    return response.data
  },

  async getPermissions(): Promise<{ permissions: Record<string, Record<string, boolean>>; role: string }> {
    const response = await apiClient.get('/user/permissions')
    return response.data
  }
}
